import { render, staticRenderFns } from "./ManagementListPage.vue?vue&type=template&id=3deebe82&scoped=true&"
import script from "./ManagementListPage.vue?vue&type=script&lang=js&"
export * from "./ManagementListPage.vue?vue&type=script&lang=js&"
import style0 from "./ManagementListPage.vue?vue&type=style&index=0&id=3deebe82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3deebe82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBreadcrumbs,VCard,VCardText,VContainer,VDivider})
